import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import DocumentType from 'modules/core/components/DocumentType'
import i18n from 'modules/core/lib/i18n'

import type EmployeePicture from 'modules/employees/store/models/EmployeePicture'

import Actions from './Actions'
import './index.styles.css'
interface Props {
  employeePicture: EmployeePicture
  canRemovePicture: boolean
  canDownloadPicture: boolean
}

const Item = ({ employeePicture, canRemovePicture, canDownloadPicture }: Props) => {
  return (
    <div className={'Item_itemWrapper'}>
      <Box
        flexGrow
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
      >
        <div className={'Item_item'}>
          <Box alignItems="center" flexGrow flexDirection="row" paddingRight="s16">
            <Box paddingRight="s16">
              <DocumentType mimetype={employeePicture.attributes.content_type} />
            </Box>
            <Box paddingRight="s16" overflowX="hidden">
              <Text.Normal weight="medium" ellipsis>
                {employeePicture.attributes.filename}
              </Text.Normal>
              <Box paddingTop="s4">
                <Text.Normal size="200" color="grey600">
                  {moment.unix(employeePicture.attributes.created_at).format('ll')}
                </Text.Normal>
              </Box>
            </Box>
          </Box>
        </div>
        {employeePicture.isInvalid && (
          <Tag type="radical">{i18n.t('employee_form.face_recognition_info.invalid')}</Tag>
        )}

        <Box flexDirection="row" gap="s8">
          <Actions
            employeePicture={employeePicture}
            canRemovePicture={canRemovePicture}
            canDownloadPicture={canDownloadPicture}
          />
        </Box>
      </Box>
    </div>
  )
}

export default observer(Item)
